import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { LtlQuoteRequestStatus } from '@graphql-types';

@Component({
  selector: 'nx-quote-request-status',
  imports: [CommonModule, MatIconModule],
  templateUrl: './quote-request-status.component.html',
  styleUrls: ['./quote-request-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuoteRequestStatusComponent {
  @Input({ required: true }) status: LtlQuoteRequestStatus;

  get currentStatus() {
    return this.statusMap[this.status] ?? this.statusMap.unknown;
  }

  statusMap = {
    unknown: {
      name: 'Unknown',
      className: 'unknown',
      icon: 'ic-unknown',
    },
    [LtlQuoteRequestStatus.Draft]: {
      name: 'Draft',
      className: 'fields',
      icon: 'ic-edit',
    },
    [LtlQuoteRequestStatus.Requested]: {
      name: 'Requested',
      className: 'orange',
      icon: 'ic-sent',
    },
    [LtlQuoteRequestStatus.Quoted]: {
      name: 'Quoted',
      className: 'link',
      icon: 'ic-quoted',
    },
    [LtlQuoteRequestStatus.PendingBooking]: {
      name: 'Pending booking',
      className: 'fields',
      icon: 'ic-time-s',
    },
    [LtlQuoteRequestStatus.Booked]: {
      name: 'Booked',
      className: 'mint',
      icon: 'ic-accepted-s',
    },
    [LtlQuoteRequestStatus.Failed]: {
      name: 'Failed',
      className: 'red',
      icon: 'ic-lost-signal',
    },
    [LtlQuoteRequestStatus.BookingFailed]: {
      name: 'Booking failed',
      className: 'red',
      icon: 'ic-lost-signal',
    },
    [LtlQuoteRequestStatus.Expired]: {
      name: 'Expired',
      className: 'red',
      icon: 'ic-expired',
    },
    [LtlQuoteRequestStatus.Cancelled]: {
      name: 'Cancelled',
      className: 'red',
      icon: 'ic-declined-s',
    },
  };
}
